import { LAUNCH_LABEL } from '../config/launch.js';

// The homepage's title and description. Plain JS with no JSX, so SEOHead (in
// the browser) and scripts/prerender.mjs (at build) read one source, the same
// pattern as lib/siteLinks.js. Before this the prerendered HTML and the page
// after load carried two different titles and descriptions, and a crawler that
// renders JavaScript could index either one.
//
// public/index.html repeats the title in static tags the prerenderer does not
// rewrite (meta title, the image alt text, the noscript heading). Keep them in
// step with this when the title changes.
export const HOME_META = {
  title: 'Pixally: The All-in-One CRM for Wedding Photographers & Videographers',
  description:
    'Replace your duct-taped stack. Pixally is the all-in-one CRM for wedding photographers, videographers, and content creators. Join the waitlist.',
};

// The one-paragraph answer to "what is Pixally". Answer engines lift the first
// clear definition they find and repeat it, so every place that describes the
// product in prose (llms.txt, the prerendered homepage, the JSON-LD in
// public/index.html) says this and nothing looser. Every clause is on the
// launch feature list in config/planComparison.js, which Ryan confirmed ships
// in full on launch day. No superlatives ("the only CRM..."): an engine that
// checks one and finds it false stops trusting the rest.
export const PIXALLY_DEFINITION =
  `Pixally is an all-in-one CRM for wedding photographers and videographers, with photo, video and hybrid gallery delivery built in. It runs a studio from first inquiry to delivered gallery: leads, proposals, contracts, payments, projects, post-production, second shooters and contractors, and the client portal. It launches on ${LAUNCH_LABEL}.`;
